import React, { Component } from 'react';
import { GBGProductQualityCheckList } from 'dashboard/GBG_products/components/GBGProductQualityCheckList';

function arrayMove(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    var k = new_index - arr.length + 1;

    while (k--) {
      arr.push(undefined);
    }
  }

  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

export const GBGProductQualityChecksComponent = (props) => {
  return (
    <div data-testid="sortable-quality-checks-list">
      <GBGProductQualityCheckList
        props={props}
        onSortEnd={({ oldIndex, newIndex }) => onSortEnd(props, oldIndex, newIndex)}
        distance={20}
        helperClass="sortable-quality-checks-list"
      />
    </div>
  );
};

function onSortEnd(props, oldIndex, newIndex) {
  const { matchingQualityChecks } = props.currentRecord;
  const updatedQualityChecks = arrayMove(matchingQualityChecks, oldIndex, newIndex);
  const firstBaseQualityCheck = props.currentRecord.matchingQualityChecks.findIndex(
    (item) => item.qualityCheckType == 'Base'
  );
  const qualityChecksToOrder = updatedQualityChecks.filter((item) => item.qualityCheckType !== 'Base');
  const matchingQualityChecksOrder = qualityChecksToOrder.map((item, index) => {
    let itemData = { ItemNumber: item.ItemNumber };

    if (!item.ItemNumber) {
      delete itemData.ItemNumber;
      itemData.Text = item.Text;
    }

    if (firstBaseQualityCheck !== -1 && index < firstBaseQualityCheck) {
      itemData.Position = 'before_base_quality_checks';
    }

    return itemData;
  });
  props.updateParentComponentState({
    currentRecord: {
      ...props.currentRecord,
      matchingQualityChecksOrderChanged: true,
      matchingQualityChecksOrder,
      matchingQualityChecks: updatedQualityChecks,
    },
  });
}
